import React from "react";
import TableFilters from "../../../Components/Common/TableFilters";

export default function SalesFilters({ dateRange, onDateRangeChange }) {
  return (
    <TableFilters
      className="sales-overview-page__filters"
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      showDateRange
    />
  );
}
